window.LoadGoogleMaps = (callback) ->
  script = document.createElement 'script'
  script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCGShaIy7ZEDt-fYtnAbQ3JGWjVRc_98ok&libraries=places"
  script.async = true
  script.defer = true
  script.onload = callback
  document.head.appendChild script
